import { useFeature } from 'src/abTesting';
import { CVR_HOMEPAGE_TERMS_CHANGES_BANNER } from '../../abTesting/features';

export function useHomepageTermsChangesBanner(): boolean {
  return useFeature(CVR_HOMEPAGE_TERMS_CHANGES_BANNER).treatment === 'on';
}
